module.exports = __webpack_public_path__ + "static/media/tree_logo.823b62fe.png";